import { AlertDTO } from "~/types/alert/alert";
import VueI18n from "vue-i18n";

export function translateAlert(alert: AlertDTO, i18n: VueI18n) {
  const { template, templateValues, msg } = alert;

  if (!template || !i18n.te(`alerts.events.${template}`)) {
    return msg;
  }

  return i18n.t(`alerts.events.${template}`, templateValues);
}
